import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import AboutUsImage from '../assets/AboutUSImage.png';
import photo from '../assets/HeadBack.webp';
import about1 from '../assets/about1.webp';
import PageBanner from './SectionPageBanner';
const AboutUs = () => {
  return (
    <Box sx={{ fontFamily: '"Rajdhani", sans-serif', backgroundColor: '#Fcfcfc' }}>
       <PageBanner image={photo} title="Who We Are" />
      <Box
      sx={{
                alignItems: 'center',
                justifyContent: 'center',
                px: {sm: 3 },
                mx: 'auto',
                mt: '50px',
                fontFamily: 'Nunito, sans-serif',
                width: {
                    xs: '90%',
                    sm: '100%',
                    md: '100%',
                    lg: '85%',
                    xl: '85%',
                },
            }}
            maxWidth="lg">
      <Box
      px={4}
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          justifyContent: 'space-between',
          // px: '20%',
          gap: 4,
          py: 1,
        } }
        >
        {/* Left Subsection */}
        <Box sx={{ flex: 1 }}>

          <Typography variant="subtitle1"  fontWeight={300} color='#686868' sx={{ fontFamily: 'Nunito' }}>
            We are driven by innovation and a commitment to delivering cutting-edge IT solutions tailored to your business needs. Founded with a vision to bridge technology and growth, we empower organizations through smart, scalable, and secure digital products. With a passionate team of experts, we specialize in web development, app solutions, and digital transformation services that ensure long-term value.
           Our collaborative approach, deep technical expertise, and focus on measurable outcomes make us a trusted partner for businesses looking to thrive in the digital age.
          </Typography>
          <Button
                    sx={{
                        mt: '50px',
                        position: 'relative',
                        overflow: 'hidden',
                        borderRadius: '3px',
                        px: '10px',
                        py: '3px',
                        textTransform: 'uppercase',
                        fontWeight: 600,
                        fontFamily: 'Rajdhani',
                        fontSize: '17px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        backgroundColor: '#0c5ADB',
                        color: '#fff',
                        border: '2px solid #0c5ADB',
                        width: 'fit-content',
                        transition:
                            'color 0.4s ease-in-out, background-color 0.4s ease-in-out',

                        '& span, & .arrow-circle': {
                            position: 'relative',
                            zIndex: 1,
                        },

                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            height: '100%',
                            width: '100%',
                            backgroundColor: '#fff',
                            zIndex: 0,
                            transform: 'translateX(100%)',
                            transition: 'transform 0.4s ease-in-out',
                        },

                        '&:hover::before': {
                            transform: 'translateX(0%)',
                        },

                        '&:not(:hover)::before': {
                            transform: 'translateX(-100%)',
                        },

                        '& .arrow-circle': {
                            backgroundColor: '#fff',
                            color: '#075AD6',
                            borderRadius: '50%',
                            padding: '3px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.4s ease-in-out',
                        },

                        '&:hover': {
                            color: '#075AD6',
                            '& .arrow-circle': {
                                backgroundColor: '#0c5ADB',
                                color: '#fff',
                            },
                        },
                    }}
                    component={Link}
                    to="/contact-us"
                >
                    <span>CONTACT US</span>
                    <span className="arrow-circle">
                        <ArrowForwardIcon fontSize="small" />
                    </span>
                </Button>
        </Box>
        <Box
          component="img"
          src={about1}
          alt="Team"
          sx={{
            width: 400,
            height: 300,
            objectFit: 'cover',
            borderRadius: 2,
            display: { xs: 'none', md: 'block' },
          }}
        />
      </Box>

      <Box textAlign="center" sx={{
    display: { xs: 'none', sm: 'block' }
  }} py={6} px={4} backgroundColor='white'  >
        <Typography variant="h2" fontFamily='Rajdhani' fontWeight={600} fontSize={'36px'}>
          Our Mission
        </Typography>
        <Typography variant="subtitle1" sx={{ fontFamily: 'Nunito',color:'#686868' }} gutterBottom fontWeight={300}>
          Empowering businesses with intuitive, reliable digital tools.
        </Typography>
        <Typography variant="body1" sx={{ fontFamily: 'Nunito', color:'#686868' }} maxWidth="800px" mx="auto" fontWeight={300}>
          We believe in crafting user-friendly interfaces and scalable solutions that make a real difference in the world. Our journey is driven by innovation, customer success, and a relentless focus on quality.
        </Typography>
      </Box>

      {/* Section 3 */}
      
    </Box>
    <Box
        sx={{
          position: 'relative',
          // height: { xs: '60vh', sm: '100vh' },
          height: '60vh',

          backgroundImage:`url(${AboutUsImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          color: '#fff',
        }}
      >
        {/* Fade overlay */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.1))',
            zIndex: 1,
          }}
        />

        {/* Text Overlay */}
        <Box
          sx={{
            position: 'relative',
            zIndex: 2,
            textAlign: 'center',
            pt: 10,

          }}maxWidth="lg"
        >
          <Typography variant="h4" component="div" fontFamily={'Rajdhani'} fontWeight={700}>
            "Building the Future with Passion & Code — combining creativity, technology, and purpose that make a difference."
          </Typography>
        </Box>
      </Box>
      </Box>
  );
};

export default AboutUs;
